//
/* eslint-disable */
import React, { useState, useCallback, useEffect } from 'react';
import styles from './style.module.scss';
import { useStore } from 'src/onboarding/store/store';
import { Title } from '../../typography/Title/Title';
import { t } from '@web-solutions/module-localization';
import { ReactComponent as CheckIcon } from '../../../assets/images/checkEmailICon.svg';
import { Caption } from '../../typography/Caption/Caption';
import Button from '../button/Button';
import Analytics from '@web-solutions/module-analytics';
import { validateEmail } from 'src/onboarding/helpers/validateEmail';
import { useDispatch } from 'react-redux';
import { useNav } from 'src/onboarding/hooks/nav';
import { processEmail } from 'src/store/profile/actions';
import { reInit as reInitRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import axios from 'axios';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
import { domains, Email } from '@smastrom/react-email-autocomplete';
import { useRemoteConfig as useCoreRemoteConfig } from 'core/hooks/use-remote-config';
import { useRemoteConfig } from 'src/hooks/use-remote-config';
import { applyFoodzeeAuthTokens } from 'src/onboarding/helpers/applyFoodzeeAuthTokens';
import Billing from '@web-solutions/module-billing';
import { getPublicKeys } from '@web-solutions/react-billing';

declare const gtag: Function;

interface UserPayload {
  email: string;
}

export const EmailPopup = ({ isOpen, onClose }) => {
  const email = useStore((state) => state.email);
  const setEmail = useStore((state) => state.setEmail);
  const setPage = useStore((state) => state.setPage);
  const setUserId = useStore((state) => state.setUserId);

  const dispatch = useDispatch();
  const { currentIndex } = useNav();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isValid, setIsValid] = useState(false);

  const { showEmailAutocomplete } = useRemoteConfig();
  const { paymentSystem } = useCoreRemoteConfig();

  const baseList = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'aol.com',
  ];
  const handleEmailChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );

  const handleInputClick = useCallback(() => {
    Analytics.trackEvent('email-popup', 'input-click');
  }, []);

  useEffect(() => {
    if (isOpen) {
      Analytics.trackEvent('email-popup', 'view');
    }
  }, [isOpen, currentIndex]);

  useEffect(() => {
    if (!email) {
      setErrorMessage('');
      setIsValid(false);
    } else if (!validateEmail(email)) {
      setErrorMessage(t('onboarding.email.errorMessage'));
      setIsValid(false);
    } else {
      setErrorMessage('');
      setIsValid(true);
    }
  }, [email]);

  const handleSubmit = useCallback(
    async (value: string) => {
      // if (!isValid) return;

      // @ts-ignore
      window.fbq('track', 'CompleteRegistration');

      console.log('[EmailPopup] handleSubmit called with email:', value);
      await dispatch(processEmail(value));
      console.log('[EmailPopup] processEmail dispatched');
      await dispatch(reInitRemoteConfig());
      console.log('[EmailPopup] reInitRemoteConfig dispatched');

      try {
        console.log('[EmailPopup] 1. Creating Stripe customer with email:', value);
        const customerResponse = await Billing.createStripeCustomer(value);
        console.log('[EmailPopup] 1. Stripe customer response:', customerResponse);

        if (customerResponse) {
          console.log('[EmailPopup] Setting userId:', customerResponse.userId);
          setUserId(customerResponse.userId);

          console.log('[EmailPopup] 2. Setting up auth and initializing billing');
          await applyFoodzeeAuthTokens(customerResponse, dispatch, {
            reinitBilling: true,
            paymentSystem,
          });

          const productsResponse = await Billing.getStripeProducts('subscription');

          console.log('[EmailPopup] 4. Initializing Stripe');
          const publicKeys = getPublicKeys();
          const publicKey = publicKeys?.stripe?.public_key;
          console.log('[EmailPopup] 4. Public key available:', !!publicKey);

          if (publicKey && (window as any).Stripe) {
            try {
              const stripeInstance = (window as any).Stripe(publicKey);
              (window as any).__stripe_instance__ = stripeInstance;
            } catch (stripeError) {
              console.error('[EmailPopup] 4. Error initializing Stripe:', stripeError);
            }
          } else {
            console.warn('[EmailPopup] 4. Cannot initialize Stripe - missing publicKey or Stripe library', {
              publicKey: !!publicKey,
              hasStripeLibrary: !!(window as any).Stripe,
            });
          }

          console.log('[EmailPopup] All Stripe initialization complete');
          onClose();
        } else {
          console.log('[EmailPopup] No response received');
        }
      } catch (error) {
        console.error('[EmailPopup] Error in handleSubmit:', error);
      } finally {
        console.log('[EmailPopup] Finally block - closing popup');
        onClose();
      }
    },
    [dispatch, isValid, setUserId, paymentSystem]
  );

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div
        className={styles.overlay}
        // onClick={() => {
        //   // onClose();
        //   Analytics.trackEvent('email-popup', 'close');
        // }}
      />

      <div className={styles.popup}>
        <Title tag='h4' className={styles.title}>
          {t('onboarding.emailPopup.title')}
        </Title>

        <div className={styles.inputContainer}>
          {showEmailAutocomplete ? (
            <Email
              id='email-field'
              value={email}
              onChange={setEmail}
              placeholder={t('onboarding.email.placeholder')}
              baseList={baseList}
              refineList={domains}
              onClick={handleInputClick}
              classNames={{
                wrapper: styles.customEmailWrapper,
                dropdown: styles.customEmailDropdown,
                input: styles.customEmailInput,
                suggestion: styles.customEmailSuggestion,
                domain: styles.customEmailDomain,
              }}
              style={{
                textAlign: 'left',
                caretColor: 'black',
              }}
            />
          ) : (
            <input
              type='email'
              value={email}
              onChange={handleEmailChange}
              onClick={handleInputClick}
              placeholder={t('onboarding.emailPopup.placeholder')}
              className={styles.emailInput}
              autoFocus={false}
            />
          )}
          <Caption size='m' className={styles.errorMessage} style={{ margin: 0 }}>
            {errorMessage}
          </Caption>
        </div>

        <div className={styles.feature}>
          <CheckIcon className={styles.checkIcon} />
          <Caption size='l' className={styles.caption}>
            {t('onboarding.emailPopup.safelyStore')}
          </Caption>
        </div>

        <Button
          className={!isValid ? 'disabled' : ''}
          title={t('onboarding.eatingHabits.continue')}
          onClick={async () => {
            // if (!isValid) return;
            await handleSubmit(email);
            Analytics.trackEvent(`email-popup`, 'complete', {
              answer: email,
            });

            gtag('event', 'conversion', {
              send_to: 'AW-17149973324/cDa6CIPlt_0aEMym3_E_',
              value: 1.0,
              currency: 'USD',
            });
          }}
        />
        <span className={styles.privacy}>
          {t('onboarding.personalPlan.plan.accept')}{' '}
          <a onClick={() => setPage('privacy-policy')}>
            {t('onboarding.personalPlan.plan.privacy')}
          </a>
          , <a onClick={() => setPage('terms-of-use')}>{t('onboarding.personalPlan.plan.terms')}</a>
        </span>
      </div>
    </>
  );
};
